import { SCENES } from "@/mocks/gua";

export default function Scenes() {
  return (
    <section id="scene" className="w-full border-b border-stone-200/60 bg-white">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-rose-500">现场直击 · 一手图文</p>
            <h2 className="mt-1.5 text-2xl font-extrabold text-stone-900 md:text-3xl">这些大场面 前排都有人拍了</h2>
            <p className="mt-2 text-sm text-stone-500">不空口吃瓜，这里放几张一手现场图，配几句短注，让你云蹲前排。</p>
          </div>
          <span className="flex items-center gap-1.5 whitespace-nowrap text-xs text-stone-400">
            <i className="ri-camera-line text-rose-500" /> 图源均来自前排围观投稿
          </span>
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-3">
          {SCENES.map((s) => (
            <a
              key={s.title}
              href="#top"
              className="group flex flex-col overflow-hidden rounded-lg border border-stone-200/70 bg-[#fdfbf6] transition hover:border-rose-200"
            >
              <div className="relative aspect-[10/7] w-full overflow-hidden bg-stone-100">
                <img
                  src={s.img}
                  alt={s.title}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-white/90 px-2.5 py-1 text-[11px] font-bold text-rose-600 backdrop-blur">
                  {s.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="whitespace-nowrap text-sm font-bold text-stone-900 transition group-hover:text-rose-600 md:text-base">
                  {s.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 flex-1 text-xs leading-relaxed text-stone-500">{s.summary}</p>
                <span className="mt-3 flex items-center gap-1 text-[11px] font-semibold text-stone-400">
                  <i className="ri-eye-line" /> {s.reads}
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* 底部 CTA */}
        <div className="mt-10 flex flex-col items-center justify-between gap-4 rounded-lg border border-orange-200/70 bg-gradient-to-br from-orange-50 to-amber-50/70 px-6 py-6 sm:flex-row md:px-8">
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-extrabold text-stone-900">漏瓜了？别慌，入口就在这</h3>
            <p className="mt-1 text-sm text-stone-600">
              从今日速递到主题合集，再从榜单到分区，照着这几个入口走，前排随时有你的位子。
            </p>
          </div>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
            <a
              href="#today"
              className="whitespace-nowrap rounded-md bg-orange-600 px-5 py-2.5 text-center text-sm font-medium text-white transition hover:bg-orange-700"
            >
              回到今日新瓜
            </a>
            <a
              href="#collection"
              className="whitespace-nowrap rounded-md border border-orange-300 bg-white px-5 py-2.5 text-center text-sm font-medium text-orange-700 transition hover:bg-orange-50"
            >
              逛逛合集索引
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}